import { TroubleEventType, TroubleEventStatus } from '../Model/TroubleEvent'

export function getTroubleEventAvailaibleStatuses(
    type: TroubleEventType,
    status: TroubleEventStatus
): Array<any> {
    // const defaultAvailableStatuses = [
    //     TroubleEventStatus.New,
    //     TroubleEventStatus.InProgress,
    //     TroubleEventStatus.Expired,
    //     TroubleEventStatus.Resolved,
    //     TroubleEventStatus.NotResolved
    // ]
    let troubleEventAvailableStatusesConfig = [
        // Sms
        {
            'type': TroubleEventType.Sms,
            'status': TroubleEventStatus.New,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.Sms,
            'status': TroubleEventStatus.InProgress,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.Sms,
            'status': TroubleEventStatus.Expired,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.Sms,
            'status': TroubleEventStatus.Resolved,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.Sms,
            'status': TroubleEventStatus.NotResolved,
            'availaibleStatuses': []
        },
        // Call
        {
            'type': TroubleEventType.Call,
            'status': TroubleEventStatus.New,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.Call,
            'status': TroubleEventStatus.InProgress,
            'availaibleStatuses': [
                TroubleEventStatus.Resolved,
                TroubleEventStatus.NotResolved
            ]
        },
        {
            'type': TroubleEventType.Call,
            'status': TroubleEventStatus.Expired,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.Call,
            'status': TroubleEventStatus.Resolved,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.Call,
            'status': TroubleEventStatus.NotResolved,
            'availaibleStatuses': []
        },
        // Collector
        {
            'type': TroubleEventType.Collector,
            'status': TroubleEventStatus.New,
            'availaibleStatuses': [
                TroubleEventStatus.InProgress
            ]
        },
        {
            'type': TroubleEventType.Collector,
            'status': TroubleEventStatus.InProgress,
            'availaibleStatuses': [
                TroubleEventStatus.New,
                TroubleEventStatus.Resolved,
                TroubleEventStatus.NotResolved
            ]
        },
        {
            'type': TroubleEventType.Collector,
            'status': TroubleEventStatus.Expired,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.Collector,
            'status': TroubleEventStatus.Resolved,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.Collector,
            'status': TroubleEventStatus.NotResolved,
            'availaibleStatuses': []
        },
        // Lawyer
        {
            'type': TroubleEventType.Lawyer,
            'status': TroubleEventStatus.New,
            'availaibleStatuses': [
                TroubleEventStatus.InProgress
            ]
        },
        {
            'type': TroubleEventType.Lawyer,
            'status': TroubleEventStatus.InProgress,
            'availaibleStatuses': [
                TroubleEventStatus.New,
                TroubleEventStatus.Resolved,
                TroubleEventStatus.NotResolved
            ]
        },
        {
            'type': TroubleEventType.Lawyer,
            'status': TroubleEventStatus.Expired,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.Lawyer,
            'status': TroubleEventStatus.Resolved,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.Lawyer,
            'status': TroubleEventStatus.NotResolved,
            'availaibleStatuses': []
        },
        // HardCall
        {
            'type': TroubleEventType.HardCall,
            'status': TroubleEventStatus.New,
            'availaibleStatuses': [
                TroubleEventStatus.InProgress
            ]
        },
        {
            'type': TroubleEventType.HardCall,
            'status': TroubleEventStatus.InProgress,
            'availaibleStatuses': [
                TroubleEventStatus.New,
                TroubleEventStatus.Resolved,
                TroubleEventStatus.NotResolved
            ]
        },
        {
            'type': TroubleEventType.HardCall,
            'status': TroubleEventStatus.Expired,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.HardCall,
            'status': TroubleEventStatus.Resolved,
            'availaibleStatuses': []
        },
        {
            'type': TroubleEventType.HardCall,
            'status': TroubleEventStatus.NotResolved,
            'availaibleStatuses': []
        },
    ]

    let filtered = troubleEventAvailableStatusesConfig
        .filter(item => status === item.status && type === item.type)
        .map(item => item.availaibleStatuses)
    return filtered.length ? filtered[0] : []
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/StatusHelper.ts